// Brand color palette

export default {
  primary: {
    base: '#262626',
    lighten5: '#FBFBFB',
    lighten4: '#F6F6F6',
    lighten3: '#F1F1F1',
    lighten2: '#E5E5E5',
    lighten1: '#C3C3C3',
    darken1: '#A5A5A5',
    darken2: '#7B7B7B',
    darken3: '#676767',
    darken4: '#474747',
    darken5: '#262626'
  },
  secondary: {
    base: '#FF9200',
    lighten5: '#FFF8E1',
    lighten4: '#FFEDB4',
    lighten3: '#FEE283',
    lighten2: '#FED751',
    lighten1: '#FECD2A',
    darken1: '#FFC40D',
    darken2: '#FFB604',
    darken3: '#FFA301',
    darken4: '#FF9200',
    darken5: '#FF7200'
  },
  error: {
    base: '#E24F4F',
    lighten5: '#FDEAED',
    lighten4: '#FACBD0',
    lighten3: '#E69798',
    lighten2: '#D96F71',
    lighten1: '#E24F4F',
    darken1: '#E63E36',
    darken2: '#D73535',
    darken3: '#C52C2F',
    darken4: '#B82528',
    darken5: '#A9191D'
  },
  info: {
    base: '#009FD9',
    lighten5: '#E1F6FB',
    lighten4: '#B4E6F6',
    lighten3: '#83D6F1',
    lighten2: '#55C6EC',
    lighten1: '#32B9E9',
    darken1: '#0BADE7',
    darken2: '#009FD9',
    darken3: '#008CC6',
    darken4: '#007BB2',
    darken5: '#005B91'
  },
  success: {
    base: '#84B752',
    lighten5: '#F2F9EB',
    lighten4: '#DEEECC',
    lighten3: '#C9E3AC',
    lighten2: '#B3D88C',
    lighten1: '#A3D072',
    darken1: '#93C75B',
    darken2: '#84B752',
    darken3: '#70A348',
    darken4: '#5E8F3E',  
    darken5: '#3E6C2E'
  },
  surfaceDark: {
    base: '#262626',
    darken1: '#111111',
    darken2: '#080808'
  },
  surfaceLight: {
    base: '#FFFFFF',
    darken1: '#FBFBFB',
    darken2: '#F6F6F6'
  },
  warning: '#FFB604',
  accent: '#FF7200',
  anchor: '#009FD9'
}